import { isUnlimited } from "@/features/subscription";

import { formatNumber } from "./numberFormatters";

export const formatLimit = (limit: number, formatter = formatNumber) =>
  isUnlimited(limit) ? "Unlimited" : formatter(limit);
